import type { MouseEvent } from 'react';

import { VFlex } from '@/components/base';
import LegendItem, {
  type LegendProps,
} from '@/components/Chart/LegendItem/LegendItem';
import useColor from '@/hooks/domain/useColor';

import { DISTRIBUTION_CHART_LEGEND } from './types';

type Props = {
  assignedSum: number;
  notAssigned: number;
  legend: LegendProps[];
  total: number;
  selectedLegend: string | DISTRIBUTION_CHART_LEGEND | null;
  onClickLegendItem: (
    e: MouseEvent,
    value: string | DISTRIBUTION_CHART_LEGEND | null,
  ) => void;
};

const LegendList = (props: Props) => {
  const color = useColor();
  return (
    <VFlex g={4} f={1}>
      <div
        onClick={(e) =>
          props.onClickLegendItem(e, DISTRIBUTION_CHART_LEGEND.TOTAL)
        }
      >
        <LegendItem
          name="Assigned total"
          value={props.assignedSum}
          color={color.primaryAlpha(0.2)}
          selected={props.selectedLegend === DISTRIBUTION_CHART_LEGEND.TOTAL}
          percentage={Number(
            ((props.assignedSum / props.total) * 100).toFixed(1),
          )}
        />
      </div>
      {props.legend.map((legend) => (
        <div
          key={legend.name}
          onClick={(e) => props.onClickLegendItem(e, legend.name)}
        >
          <LegendItem
            {...legend}
            selected={props.selectedLegend === legend.name}
          />
        </div>
      ))}
      <LegendItem
        name="Not assigned"
        value={props.notAssigned}
        color={color.gray300}
        selected={
          props.selectedLegend === DISTRIBUTION_CHART_LEGEND.NOT_ASSIGNED
        }
        percentage={Number(
          ((props.notAssigned / props.total) * 100).toFixed(1),
        )}
      />
    </VFlex>
  );
};

export default LegendList;
